import { connect } from 'react-redux';
import CRUDAction from '../../../actions/participant';
import ParticipantNew from './ParticipantNew';

export default connect(
  () => ({
    loading: false,
    title: 'Create participant'
  }),
  dispatch => ({
    init: () => dispatch(CRUDAction.createModel())
  })
)(ParticipantNew);




// WEBPACK FOOTER //
// ./src/components/Participants/ParticipantsNew/index.js